/* angular:styles/component:css;059f29e72e62d859062cbc89d7e906c39c736db089d571a60b1708e497fea625;/src/src/app/edge/settings/app/formly/formly-hint.ts */
.formly-hint {
  --min-height: 30px;
}
.formly-hint ion-icon {
  margin-right: 8px;
}
.formly-hint ion-text {
  font-size: 0.8rem;
  line-height: 1.2;
}
.formly-hint.info ion-icon {
  color: #052b5c;
}
.formly-hint.warning ion-icon {
  color: var(--ion-color-warning);
}
.formly-hint.error ion-icon {
  color: var(--ion-color-danger);
}
/*# sourceMappingURL=formly-hint.css.map */
